import Immutable from 'immutable';

export const isImmutable = (object) => (Immutable.Iterable.isIterable(object));
